import React from "react";
import LeadsSearchBar from "./LeadsSearchBar";
import LeadsFilterGrid from "./LeadsFilterGrid";
import LeadsDateRange from "./LeadsDateRange";

/**
 * Filter panel for the Leads list. Fully controlled — parent (`Leads.jsx`)
 * owns the state. Rendering is delegated to three focused sub-components:
 * search bar, filter grid, date range.
 */
export default function LeadsFilters({
  q, setQ,
  status, setStatus,
  deliveryStatus, setDeliveryStatus,
  clientId, setClientId,
  affiliateId, setAffiliateId,
  state, setState,
  isTest, setIsTest,
  deliveredTo, setDeliveredTo,
  landingPage, setLandingPage,
  archived, setArchived,
  dateFrom, setDateFrom,
  dateTo, setDateTo,
  clients, affiliates,
  isInternal,
  onApply,
  onDateRangePreset,
}) {
  return (
    <div className="brut-card p-4 space-y-4" data-testid="lead-filters">
      <LeadsSearchBar q={q} setQ={setQ} onApply={onApply} />
      <LeadsFilterGrid
        status={status} setStatus={setStatus}
        deliveryStatus={deliveryStatus} setDeliveryStatus={setDeliveryStatus}
        clientId={clientId} setClientId={setClientId}
        affiliateId={affiliateId} setAffiliateId={setAffiliateId}
        state={state} setState={setState}
        isTest={isTest} setIsTest={setIsTest}
        deliveredTo={deliveredTo} setDeliveredTo={setDeliveredTo}
        landingPage={landingPage} setLandingPage={setLandingPage}
        clients={clients} affiliates={affiliates}
        isInternal={isInternal}
      />
      {isInternal && setIsTest && (
        <div className="flex flex-wrap items-center gap-2" data-testid="leads-test-filter">
          <span className="label-mono">Show:</span>
          {[
            { k: "", label: "All leads" },
            { k: "false", label: "Real leads" },
            { k: "true", label: "Test leads" },
          ].map((t) => (
            <button key={t.k || "all"} type="button" onClick={() => setIsTest(t.k)} data-testid={`leads-test-${t.k || "all"}`}
              className={`border border-black px-2 py-1 text-[10px] uppercase tracking-widest ${
                (isTest || "") === t.k ? (t.k === "true" ? "bg-yellow-400 text-black" : "bg-black text-white") : "hover:bg-black hover:text-white"
              }`}>
              {t.label}
            </button>
          ))}
          {isTest === "true" && (
            <span className="text-[11px] text-zinc-600" data-testid="leads-test-note">
              Every test lead, plus real leads you sent to a buyer as a test.
            </span>
          )}
        </div>
      )}
      {isInternal && setArchived && (
        <div className="flex items-center gap-2" data-testid="leads-archived-filter">
          <span className="label-mono">Archive:</span>
          {[
            { k: "active",   label: "Active" },
            { k: "archived", label: "Archived" },
            { k: "all",      label: "All" },
          ].map((t) => (
            <button
              key={t.k}
              type="button"
              onClick={() => setArchived(t.k)}
              data-testid={`leads-archived-${t.k}`}
              className={`border border-black px-2 py-1 text-[10px] uppercase tracking-widest ${
                (archived || "active") === t.k ? "bg-black text-white" : "hover:bg-black hover:text-white"
              }`}
            >
              {t.label}
            </button>
          ))}
        </div>
      )}
      <LeadsDateRange
        dateFrom={dateFrom} setDateFrom={setDateFrom}
        dateTo={dateTo} setDateTo={setDateTo}
        onDateRangePreset={onDateRangePreset}
      />
    </div>
  );
}
